<!-- 陆股通 -->
<template>
  <div class="dbcaptial-wrap">
    <vue-loading 
      v-if="isshowloading"
      style="margin-top: 60px;"
      type="bars" 
      color="#d9544e" 
      :size="{ width: '50px', height: '50px' }"
    ></vue-loading>
    <div class="tabs">
      <div
        v-for="(item, i) in tab.text"
        :ref="'lgt' + i"
        :class="['tab', i === tab.index  && 'active']"
        :key=i
        @click="tab.index = i;changetab()"
      >{{item}}</div>
      <div :ltip="szmessage" class="tips"></div>
    </div>

    <div class="chart-1">
      <ChartTpl
        :enableResize='true'
        :elementId='"lgtCircle1"'
        :width='"100%"'
        :height='"120px"'
        :option='circleOption'
        :originData='circleData'
      ></ChartTpl>
    </div>
    <div class="chart debug">
      <!-- {{tab.text[tab.index]}}的图 -->
      <ChartTpl
        v-show="tab.index === 0"
        :elementId='"lgtLine0"'
        ref="lgtLine0"
        :firstTooltip='true'
        :enableResize='true'
        :width='"100%"'
        :height='"248px"'
        :option='line0Option'
        :originData='line0Data'
        ></ChartTpl>

        <template v-if="alreadyLoad1">
          <ChartTpl
            v-show="tab.index === 1"
            :elementId='"lgtLine1"'
            ref="lgtLine1"
            :firstTooltip='true'
            :enableResize='true'
            :width='"100%"'
            :height='"248px"'
            :option='line1Option'
            :originData='line1Data'
          ></ChartTpl>
        </template>

        <template v-if="alreadyLoad2">
          <ChartTpl
            v-show="tab.index === 2"
            :elementId='"lgtLine2"'
            ref="lgtLine2"
            :firstTooltip='true'
            :enableResize='true'
            :width='"100%"'
            :height='"248px"'
            :option='line2Option'
            :originData='line2Data'
          ></ChartTpl>
        </template>
    </div>

  </div>
</template>

<script>
import ChartTpl from '@/components/ChartTpl.vue';
import { VueLoading } from 'vue-loading-template';

export default {
  name: "LGT",
  components: {
    ChartTpl,
    VueLoading
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    lgtLiquidity:{
      type: Object,
      default: function () {
        return {}
      }
    },
    lgtLiquiditySeries:{
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      tab: {
        index: 0,
        text: ["陆股通", "QFII和RQFII", "公募基金"]
      },
      szmessage: '陆股通：沪股通和深股通的合称。沪股通指外资通过沪港交易所互联通道买卖上海股票，深股通指外资通过深港交易所互联通道买卖深圳股票',
      line0Option: {},
      line0Data:[],
      line1Option: {},
      line1Data:[],
      line2Option: {},
      line2Data:[],
      circleOption: {},
      circleData:[],
      QFIIRQFIISeries: [],
      fundIssuanceMoneySeries: [],
      alreadyLoad1: false,
      alreadyLoad2: false,
      isshowloading: false
    };
  },
  watch: {
    lgtLiquiditySeries: {
      handler(newvalue, oldvalue){
        this.init();
      }
    },
    QFIIRQFIISeries:{
      handler(newvalue, oldvalue){
        this.initLine2();
      }
    },
    fundIssuanceMoneySeries: {
      handler(newvalue, oldvalue){
        this.initLine3();
      }
    },
    'tab.index':{
      handler(newvalue, oldvalue){
        let alreadyLoadStr = 'alreadyLoad'+newvalue;
        let getDataStr = 'getData'+newvalue;

        if (newvalue !== 0) {
          if(!this[alreadyLoadStr]) this[getDataStr]();
          this[alreadyLoadStr] = true;
        }

        setTimeout(()=>{
          this.$refs['lgtLine'+newvalue].resize();
        })
      }
    }
  },
  mounted() {
    this.report()
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.lgtLiquiditySeries.length) return;
    this.init();
  },
  methods:{
    report () {
      let ta = [{ id: 'pcweb_hgdata_lgt' }, { id: 'pcweb_hgdata_qfii' }, { id: 'pcweb_hgdata_gmjj' }]
      for (let i = 0; i < 3; i++) {
        let elm = this.$refs['lgt'+i][0]
        TA.logElementClick(elm, ta[i])
      }
    },
    changetab(){
      if(this.tab.index == 0)
      {
        this.szmessage = '陆股通：沪股通和深股通的合称。沪股通指外资通过沪港交易所互联通道买卖上海股票，深股通指外资通过深港交易所互联通道买卖深圳股票'
      }
      if(this.tab.index == 1)
      {
        this.szmessage = 'QFII和RQFII：QFII指合格的境外机构投资者，RQFII指人民币的合格境外机构投资者'
      }
      if(this.tab.index == 2)
      {
        this.szmessage = '公募基金：以公开方式向社会公众投资者募集资金并以证券为投资对象的证券投资基金'
      }
    },
    getData1(){
      this.isshowloading = true;
      this.$api.blockAPI
        .getQFIIRQFIIseries()
        .then(res => {
          if (res.code === 0) {
            this.QFIIRQFIISeries = res.data.QFIIRQFIISeries;
            this.isshowloading = false;
          }
        })
        .catch(e => {});
    },
    getData2(){
      this.isshowloading = true;
      this.$api.blockAPI
        .getFundIssuanceMoneySeries()
        .then(res => {
          if (res.code === 0) {
            this.fundIssuanceMoneySeries = res.data.fundIssuanceMoneySeries;
            this.isshowloading = false;
          }
        })
        .catch(e => {});
    },
    initCircle(){
      let {lgtLiquidity, QFII, RQFII, fundIssuanceSize } = this.lgtLiquidity;
      this.circleOption = this.$chartConfigs.fourCircle();
      this.circleOption.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: '陆股通',
          values: [
            {
              value: lgtLiquidity.percentile,
              show: lgtLiquidity.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: 'QFII',
          values: [
            {
              value: QFII.percentile,
              show: QFII.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: 'RQFII',
          values: [
            {
              value: RQFII.percentile,
              show: RQFII.value 
            }
          ]
        }, {
          min: 0,
          max: 1,
          title: '公募基金',
          values: [
            {
              value: fundIssuanceSize.percentile,
              show: fundIssuanceSize.value 
            }
          ]
        }]
      };

      this.circleData = this.circleOption.data;
    },
    initLine(){
      this.line0Option = this.$chartConfigs.line1({
        name:'陆股通', 
        dataKey:'lgt_net_captial_inflow'
      });
      this.line0Data = [{
          originData: this.lgtLiquiditySeries
        }]
    },
    initLine3(){
      this.line2Option = this.$chartConfigs.line1({
        name:'公募基金', 
        dataKey:'fund_issuance_money'
      });
      this.line2Data = [{
        originData: this.fundIssuanceMoneySeries
      }]
    },
    initLine2(){
      this.line1Option = this.$chartConfigs.line2NoDataZoom({
        line1: {
          name:'QFII', 
          // lineColor: this.$chartConfigs.projectColors.red,
          dataKey:'QFII'
        },
        line2: {
          name:'RQFII', 
          lineColor: this.$chartConfigs.projectColors.red,
          dataKey:'RQFII'
        }
      });
      this.line1Data = [{
        originData: this.QFIIRQFIISeries
      }]
    },
    init(){
      this.initLine();
      this.initCircle();
    }
  }
};
</script>

<style scoped>

.dbcaptial-wrap {
  font-size: 14px;
  display: flex;
  flex-direction: column;
}
.tabs {
  display: flex;
  margin-bottom: 10px;
  flex: 0 0 auto;
  align-items: center;
  /* font-weight: 700; */
}
.tab {
  border: 1px solid #3b3c41;
  padding: 2px 12px;
  margin-left: -1px;
  cursor: pointer;
}
.tab.active {
  background: #3b3c41;
  color: #fff;
  cursor: default;
}

.chart-1 {
  height: 120px;
  flex: 0 0 auto;
  margin-bottom: 1px;
}

.chart {
  flex: 1 1 auto;
}
.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:24px;
  height: 16px;
}
.vue-loading {
  position: absolute;
  top: 50%;
  left: 40%;
  z-index: 9999;
}
</style>
